import { getScreen } from '../utils/tailwindConfigReader';

/**
 * Media queries matching the Tailwind breakpoints, so JS and the `lg:` / `md:`
 * utility classes can never disagree. Derived from the Tailwind theme rather
 * than restating pixel values, which had been hand-copied at each call site.
 *
 * "Cannot disagree" holds because there is one copy of the numbers:
 * `src/constants/screens.json`, which tailwind.config.cjs and
 * tailwindConfigReader both read. SCSS reaches the same values with
 * `theme('screens.…')`.
 *
 * `below(name)` is the JS complement of a `name:` utility class: BELOW_LG is
 * true exactly where `lg:` classes do NOT apply.
 */
const below = (screen: string): string => {
  const px = parseInt(getScreen(screen), 10);
  return `(max-width: ${px - 1}px)`;
};

/** Narrow: phone or tablet — anywhere the `lg:` desktop treatment is off. */
export const BELOW_LG = below('lg');

/** Phone only — tablets are above this. */
export const BELOW_MD = below('md');
